module.exports = __webpack_public_path__ + "static/media/wsServicesLogo.d5d133ca.jpg";